import PropTypes from 'prop-types'
import { useState } from 'react'
import { useCXone } from '../../Utils/hooks/useCXone'
import { Button } from '@mui/material'
import { Circle } from '@mui/icons-material'

export default function NiceStatusButton({ isAdmin }) {
  if (isAdmin) return null

  const { authenticate, isAuthenticated } = useCXone()
  const [isAuthenticatedNice, setIsAuthenticatedNice] = useState(() =>
    isAuthenticated()
  )

  const handleLogin = async () => {
    await authenticate()
    const status = isAuthenticated()
    setIsAuthenticatedNice(status)
  }

  return (
    <Button
      onClick={handleLogin}
      sx={{ display: 'flex', alignItems: 'center', gap: 1, float: 'right' }}
    >
      Nice status
      <Circle
        sx={{
          fontSize: 16,
          color: isAuthenticatedNice ? 'success.main' : 'error.main', // green if true, red if false
        }}
      />
    </Button>
  )
}

NiceStatusButton.propTypes = {
  isAdmin: PropTypes.bool,
}
